import { useEffect, useState } from "react";

/** Require a continuous condition; clear the hint as soon as it stops. */
export function useDelayedWalletHint(active: boolean, delay: number): boolean {
    const [elapsed, setElapsed] = useState(false);
    useEffect(() => {
        setElapsed(false);
        if (!active) return;
        const timer = setTimeout(() => setElapsed(true), delay);
        return (): void => clearTimeout(timer);
    }, [active, delay]);
    return active && elapsed;
}
